<app-bread-crumb [Locations]="[{target : 'home', label : 'Home'}]" current="About Beachwatch">
</app-bread-crumb>

<app-hero-banner title="About Beachwatch"></app-hero-banner>
 
<div class="nsw-container nsw-container-bw">
	<div class="nsw-layout">
		<div class="nsw-layout__main">
			<h2>What is Beachwatch?</h2>
			<div class="video-text">
				<div class="about-bw-text">
					<p>
						Beachwatch has helped people make informed decisions about where and when to swim since 1989. 
						We support local councils to monitor their swim sites and provide high-quality data and information on 
						water quality for communities across New South Wales.						
					</p>
					<div class="about-program-btn-container-desktop">
						<button type="button" [routerLink]="['/waterMonitoring']"
							class="nsw-button nsw-button--dark about-program-btn">
							Learn more about the program
						</button>		
					</div>
				</div>
				<figure>
					<div>
						<app-angular-video-player [options]="videoPlayerOptions" class="video-player"></app-angular-video-player>
					</div>	
					<figcaption>{{aboutBeachwatchVideoCaption}}</figcaption>
				</figure>				
			</div>

			<div class="about-program-btn-container-mobile">
				<button type="button" [routerLink]="['/waterMonitoring']"
					class="nsw-button nsw-button--dark about-program-btn">
					Learn more about the program
				</button>		
			</div>			
		</div>
	</div>
</div>

<div class="nsw-container">
	<h2>You may also be interested in</h2>
	<div class="nsw-grid interested-in">
		<div class="nsw-col nsw-col-md-6 nsw-col-lg-4">
			<div class="nsw-content-block">
				<app-content-card title="Our vision for the future"
					description="Find out about our 10-year plan to meet increasing community demand for information on safe swim sites throughtout New South Wales"
					[link]="BEACHWATCH_VISION_URL" [isExternalLink]="true">
				</app-content-card>
			</div>
		</div>
		<div class="nsw-col nsw-col-md-6 nsw-col-lg-4">
			<div class="nsw-content-block">
				<app-content-card title="About swim safety"
					description="Learn about the best ways to stay safe at your favourite swimming spot."
					[link]="['../safeToSwim']" [isExternalLink]="false">
				</app-content-card>
			</div>
		</div>
		<div class="nsw-col nsw-col-md-6 nsw-col-lg-4">
			<div class="nsw-content-block">
				<app-content-card title="Contact Beachwatch"
					description="Get in touch to ask a question or provide feedback on our program."
					[link]="['/contactUs']" [isExternalLink]="false">
				</app-content-card>
			</div>
		</div>
	</div>
</div>